import { PrintApiService } from "../../shared/print-api/PrintApiService";
import { PeripheralServiceConfig, PeripheralType } from "../../shared/types";
import { PrintApiPrinter, PrintApiServiceConfig, PrintApiPrinterType } from "../../shared/print-api/types";
import { PrintApiLabelPrinter } from "./PrintApiLabelPrinter";

export class PrintApiLabelPrinterService extends PrintApiService<PrintApiLabelPrinter> {
  constructor(config: Partial<PeripheralServiceConfig> & PrintApiServiceConfig) {
    super(PeripheralType.labelPrinter, "PrintApiLabelPrinterService", config);
  }

  protected createPrinter(device: PrintApiPrinter): PrintApiLabelPrinter {
    return new PrintApiLabelPrinter(device);
  }
  
  protected shouldIncludePrinter(device: PrintApiPrinter): boolean {
    return device.type === PrintApiPrinterType.label;
  }
}
